module.exports = __webpack_public_path__ + "img/V73.50453ab0.jpg";